/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:06 GMT
 *
 */

import PaletteIconPause from '@telus-uds/palette-koodo/build/rn/icons/Pause'
import PaletteIconPlaySolid from '@telus-uds/palette-koodo/build/rn/icons/PlaySolid'
import PaletteIconReplay from '@telus-uds/palette-koodo/build/rn/icons/Replay'
const theme = {
  appearances: {},
  rules: [],
  tokens: {
    borderColor: '#000000',
    pauseIcon: PaletteIconPause,
    playIcon: PaletteIconPlaySolid,
    replayIcon: PaletteIconReplay
  }
}
export default theme
